import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { HttpEventType } from '@angular/common/http';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { ManagePukalService } from '../../services/manage-pukal.service';
import { saveAs } from 'file-saver/FileSaver';

@Component({
    selector: 'dialog-download-file',
    templateUrl: 'dialog.downloadFile.html',
})
export class ManagePukalDownloadFileDialog implements OnInit, OnDestroy {
    allSub: Subscription[] = [];
    errorMessage: string = '';
    loading: boolean = false;
    downloadFile: boolean = false;
    downloadFileProgress: number = 0;

    constructor(private managePukalService: ManagePukalService,
        public dialogRef: MatDialogRef<ManagePukalDownloadFileDialog>,
        @Inject(MAT_DIALOG_DATA) public model: any) { }

    ngOnInit() {
        let sub = this.managePukalService.downloadListFiles(this.model.downloadParameter)
            .subscribe(
                (event) => {
                    if (event.type === HttpEventType.UploadProgress) {
                        this.loading = true;
                        this.downloadFile = false;
                    } else if (event.type === HttpEventType.DownloadProgress) {
                        this.loading = false;
                        this.downloadFile = true;
                        this.downloadFileProgress = Math.round(100 * event.loaded / event.total);
                    }
                    else if (event.type === HttpEventType.Response) {
                        let blob = new Blob([event.body], { type: 'application/vnd.ms-excel' });
                        saveAs(blob, 'Pukal List.xls');

                        this.dialogRef.close({
                            status: 1,
                            message: 'Download completed.'
                        });
                    }
                },
                (error) => {
                    this.errorMessage = <any>error;
                    this.dialogRef.close({
                        status: -1,
                        message: this.errorMessage
                    });
                });

        // Adds into array for each subscribe
        this.allSub.push(sub);
    }

    ngOnDestroy() {
        for (let sub of this.allSub) {
            sub.unsubscribe();
        }
    }
}